"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allReducers = void 0;
var redux_1 = require("redux");
var connected_react_router_1 = require("connected-react-router");
var sok_reducers_1 = require("@caddigital/sok-reducers");
var viewport_1 = require("./viewport");
var fileUploadModal_1 = require("./fileUploadModal");
var bidMessageAttachments_1 = require("./bidMessageAttachments");
var bidQuestionAnswerFile_1 = require("./bidQuestionAnswerFile");
var navigation_1 = require("./navigation");
var metadataEditorModal_1 = require("./metadataEditorModal");
var overlay_1 = require("./overlay");
var sokositeEntryAttachments_1 = require("./sokositeEntryAttachments");
var trmeterRemarkImages_1 = require("./trmeterRemarkImages");
var store_1 = require("../store");
exports.allReducers = {
    activity: sok_reducers_1.reducers.activity.activity,
    auth: sok_reducers_1.reducers.auth.default,
    bid: sok_reducers_1.reducers.bid.default,
    briefcase: sok_reducers_1.reducers.briefcase.default,
    customer: sok_reducers_1.reducers.customer.customer,
    firstLogin: sok_reducers_1.reducers.firstLogin.default,
    info: sok_reducers_1.reducers.info.default,
    project: sok_reducers_1.reducers.project.project,
    projects: sok_reducers_1.reducers.projects.projects,
    subproject: sok_reducers_1.reducers.subproject.default,
    files: sok_reducers_1.reducers.files.files,
    revisions: sok_reducers_1.reducers.revisions.revisions,
    cart: sok_reducers_1.reducers.cart.cart,
    user: sok_reducers_1.reducers.user.user,
    users: sok_reducers_1.reducers.users.users,
    features: sok_reducers_1.reducers.features.default,
    congrid: sok_reducers_1.reducers.congrid.default,
    navigation: navigation_1.navigation,
    router: (0, connected_react_router_1.connectRouter)(store_1.history),
    reports: sok_reducers_1.reducers.reports.default,
    viewport: viewport_1.viewport,
    fileUploadModal: fileUploadModal_1.fileUploadModal,
    bidMessageAttachments: bidMessageAttachments_1.bidMessageAttachments,
    bidQuestionAnswerFile: bidQuestionAnswerFile_1.bidQuestionAnswerFile,
    distribution: sok_reducers_1.reducers.distribution.distribution,
    order: sok_reducers_1.reducers.order.order,
    translations: sok_reducers_1.reducers.translations.translations,
    overlay: overlay_1.overlay,
    metadataEditorModal: metadataEditorModal_1.metadataEditorModal,
    tasks: sok_reducers_1.reducers.tasks.tasks,
    toast: sok_reducers_1.reducers.toast.toast,
    compare: sok_reducers_1.reducers.compare.compare,
    sso: sok_reducers_1.reducers.SSO.sso,
    modelspace: sok_reducers_1.reducers.modelspace.modelspace,
    management: sok_reducers_1.reducers.management.default,
    sokosite: sok_reducers_1.reducers.sokosite.default,
    diaryentries: sok_reducers_1.reducers.diaryentries.default,
    sokositeEntryAttachments: sokositeEntryAttachments_1.sokositeEntryAttachments,
    trmvrmeterentries: sok_reducers_1.reducers.trmvrmeterentries.default,
    trmeterRemarkImages: trmeterRemarkImages_1.trmeterRemarkImages,
    vektorio: sok_reducers_1.reducers.vektorio.default,
    ytj: sok_reducers_1.reducers.ytj.default,
    // Sokobid portal reducers
    // Todo remove from type and/or move to sokobid repo
    register: undefined,
    bidinfo: undefined
};
exports.default = (0, redux_1.combineReducers)(exports.allReducers);
